import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="grain min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-md" data-testid="payment-cancel-page">
        <XCircle className="w-14 h-14 text-qbfg/40 mx-auto mb-6" />
        <h1 className="font-display text-4xl">Checkout cancelled</h1>
        <p className="text-qbfg/55 mt-4">No charge was made. The animal is still available if you'd like to try again.</p>
        <Link to="/shop" className="inline-block mt-8 px-7 py-3.5 rounded-full bg-qbprimary text-qbbg hover:bg-qbfg transition-colors">Back to collection</Link>
      </div>
    </div>
  );
}
